import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../Layout";
import { Table } from "flowbite-react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaDownload } from "react-icons/fa6";
import { MdTableChart } from "react-icons/md";

const StuudentsNotAttended = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);

  const notAttendedStudents = location.state?.notAttendedStudents || [];

  // CSV DOWNLOAD FUNCTION
  const handleDownloadCSV = () => {
    if (notAttendedStudents.length === 0) {
      alert("No students to download");
      return;
    }

    const rows = notAttendedStudents.map((student) => ({
      Name: student.name,
      Roll_Number: student.rollNo,
      Department: student.department || "-",
      Email: student.email,
    }));

    const header = Object.keys(rows[0]).join(",") + "\n";

    const csvContent =
      header +
      rows
        .map((r) =>
          Object.values(r)
            .map((val) => `"${(val || "").toString().replace(/"/g, '""')}"`)
            .join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Students_Not_Attended.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <AdminLayout>
      <div className="p-4 bg-white rounded-lg shadow-lg sm:p-5 md:p-6 min-h-screen pb-8">
        <div className="flex flex-col items-start justify-between gap-4 mb-6 sm:flex-row sm:items-center sm:mb-8">
          <div className="flex items-center">
            <button onClick={() => navigate(-1)}>
              <IoMdArrowRoundBack className="w-5 h-5 text-gray-600 sm:w-6 sm:h-6" />
            </button>
            <h2 className="ml-2 text-lg font-bold sm:text-xl md:text-2xl">Students Not Attended</h2>
          </div>
          <div className="flex flex-col w-full gap-2 sm:flex-row sm:gap-3 sm:w-auto">
            <div className="relative">
              <button
                onClick={() => setShowDownloadDropdown((prev) => !prev)}
                className="inline-flex items-center justify-center w-9 h-9 text-slate-600 transition-all hover:text-slate-900 focus:outline-none"
                title="Download"
                aria-label="Download"
              >
                <FaDownload size={20} />
              </button>

              {showDownloadDropdown && (
                <div className="absolute top-0 right-[calc(100%+10px)] z-20 w-[165px] rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_10px_24px_rgba(2,6,23,0.08)]">
                  <p className="mb-2 px-2 text-[11px] font-semibold tracking-wide text-slate-500 uppercase">
                    Choose format
                  </p>
                  <button
                    onClick={() => {
                      handleDownloadCSV();
                      setShowDownloadDropdown(false);
                    }}
                    className="flex w-full items-center gap-2.5 rounded-xl px-2.5 py-2 text-left text-slate-700 transition-colors hover:bg-slate-100"
                  >
                    <span className="rounded-lg bg-slate-100 p-1.5 text-slate-600">
                      <MdTableChart size={17} />
                    </span>
                    <span className="text-sm font-medium">CSV</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="-mx-4 overflow-x-auto sm:mx-0">
          <Table className="min-w-[600px] text-gray-500 shadow-none border-none">
            <Table.Head style={{backgroundColor: '#5c7a94'}}>
              <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-3 py-2 text-[10px] text-center text-white sm:px-4 sm:py-2.5 sm:text-xs">S.No</Table.HeadCell>
              <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-3 py-2 text-[10px] text-center text-white sm:px-4 sm:py-2.5 sm:text-xs">Name</Table.HeadCell>
              <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-3 py-2 text-[10px] text-center text-white sm:px-4 sm:py-2.5 sm:text-xs">Roll No</Table.HeadCell>
              <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-3 py-2 text-[10px] text-center text-white sm:px-4 sm:py-2.5 sm:text-xs">Department</Table.HeadCell>
              <Table.HeadCell style={{backgroundColor: '#5c7a94'}} className="px-3 py-2 text-[10px] text-center text-white sm:px-4 sm:py-2.5 sm:text-xs">Email</Table.HeadCell>
            </Table.Head>

            <Table.Body className="bg-white">
              {notAttendedStudents.length > 0 ? (
                notAttendedStudents.map((student, idx) => (
                  <Table.Row key={student.id} className={`transition duration-150 ease-in-out hover:bg-blue-50/60 ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                    <Table.Cell className="px-2 py-2 text-xs font-medium text-center text-gray-700 border-none sm:px-4 md:px-6 sm:py-3 sm:text-sm md:text-base">{idx + 1}</Table.Cell>
                    <Table.Cell className="px-2 py-2 text-xs text-center border-none sm:px-4 md:px-6 sm:py-3 sm:text-sm md:text-base whitespace-nowrap">{student.name}</Table.Cell>
                    <Table.Cell className="px-2 py-2 text-xs text-center border-none sm:px-4 md:px-6 sm:py-3 sm:text-sm md:text-base whitespace-nowrap">{student.rollNo}</Table.Cell>
                    <Table.Cell className="px-2 py-2 text-xs text-center border-none sm:px-4 md:px-6 sm:py-3 sm:text-sm md:text-base whitespace-nowrap">
                      {student.department && String(student.department).trim() !== "" ? student.department : "-"}
                    </Table.Cell>
                    <Table.Cell className="px-2 py-2 text-xs text-center border-none sm:px-4 md:px-6 sm:py-3 sm:text-sm md:text-base">{student.email}</Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan={5} className="py-4 text-xs text-center border-none sm:text-sm md:text-base">
                    All students attended.
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default StuudentsNotAttended;
